import { render, staticRenderFns } from "./EditLocationForm.vue?vue&type=template&id=2df472e0&scoped=true&"
import script from "./EditLocationForm.vue?vue&type=script&lang=js&"
export * from "./EditLocationForm.vue?vue&type=script&lang=js&"
import style0 from "./EditLocationForm.vue?vue&type=style&index=0&id=2df472e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df472e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VTextField,VTextarea})
